export function MainContent({ children }) {
  return <main className="flex-grow-1">{children}</main>;
}
